import type {
	NastaveniApiActualDto,
	UserSettingFavorites,
	UserSettingRecentVisited,
	UserSettingSearchTerms,
} from '@gov-nx/api/types/userSettings';
import {
	isFavoritesDTO,
	isRecentVisitedDTO,
	isSearchTermDTO,
} from '@gov-nx/api/types/userSettings';
import type { Optional } from '@gov-nx/core/types/helpers.types';

export const getFavoritesFromDTO = (
	setting: NastaveniApiActualDto[]
): Optional<UserSettingFavorites> => {
	const favorites = setting.find(isFavoritesDTO);
	if (favorites) {
		return { key: favorites.klic, value: favorites.hodnota };
	}
	return undefined;
};

export const getSearchTermsFromDTO = (
	setting: NastaveniApiActualDto[]
): Optional<UserSettingSearchTerms> => {
	const searchTerms = setting.find(isSearchTermDTO);
	if (searchTerms) {
		return { key: searchTerms.klic, value: searchTerms.hodnota };
	}
	return undefined;
};

export const getRecentVisitedFromDTO = (
	setting: NastaveniApiActualDto[]
): Optional<UserSettingRecentVisited> => {
	const recentVisited = setting.find(isRecentVisitedDTO);
	if (recentVisited) {
		return { key: recentVisited.klic, value: recentVisited.hodnota };
	}
	return undefined;
};
